export default __webpack_public_path__ + "assets/puertoAventuras.0cae9d7c.jpg";